import React, { useState } from 'react';
import '../../styles/pages/mobileAccountDeletion.scss';

const MobileAccountDeletion = () => {
    const [step, setStep] = useState(1); // 1: Email girişi, 2: Kod onayı, 3: Başarılı
    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [deletionInfo, setDeletionInfo] = useState(null);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!email.trim()) {
            setError('Lütfen e-posta adresinizi giriniz.');
            return;
        }

        if (!validateEmail(email.trim())) {
            setError('Lütfen geçerli bir e-posta adresi giriniz.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/mobile/account-deletion/request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email.trim() }),
            });

            const result = await response.json();

            if (result.isSuccess) {
                setMessage(result.resultMessage || 'Doğrulama kodu e-posta adresinize gönderildi.');
                setStep(2);
            } else {
                setError(result.resultMessage || 'E-posta gönderilirken bir hata oluştu.');
            }
        } catch (err) {
            setError('Bir hata oluştu. Lütfen tekrar deneyiniz.');
        } finally {
            setLoading(false);
        }
    };

    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!verificationCode.trim()) {
            setError('Lütfen doğrulama kodunu giriniz.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/mobile/account-deletion/confirm`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email.trim(),
                    verificationCode: verificationCode.trim(),
                }),
            });

            const result = await response.json();

            if (result.isSuccess) {
                setDeletionInfo(result.data);
                setMessage(result.resultMessage || 'Hesap silme talebiniz onaylandı.');
                setStep(3);
            } else {
                setError(result.resultMessage || 'Doğrulama kodu hatalı. Lütfen tekrar deneyiniz.');
            }
        } catch (err) {
            setError('Bir hata oluştu. Lütfen tekrar deneyiniz.');
        } finally {
            setLoading(false);
        }
    };

    const handleResetForm = () => {
        setStep(1);
        setEmail('');
        setVerificationCode('');
        setError('');
        setMessage('');
        setDeletionInfo(null);
    };

    return (
        <div className="mobile-account-deletion-page">
            <div className="container">
                <header className="mad-header">
                    <h1>Mobil Hesap Silme</h1>
                    <p>
                        Mobil uygulama hesabınızı kalıcı olarak silmek için e-posta adresinizi giriniz.
                        E-postanıza gönderilen doğrulama kodu ile işlemi onayladıktan sonra hesabınız
                        10 gün içerisinde silinecektir.
                    </p>
                </header>

                {error && <div className="mad-alert mad-alert-error">{error}</div>}
                {message && step === 2 && <div className="mad-alert mad-alert-info">{message}</div>}

                {step === 1 && (
                    <div className="mad-step mad-step-1">
                        <form className="mad-form" onSubmit={handleEmailSubmit}>
                            <div className="mad-info">
                                <div className="mad-info-icon">⚠️</div>
                                <div className="mad-info-content">
                                    <h3>Önemli Bilgilendirme</h3>
                                    <ul>
                                        <li>Hesabınız silindikten sonra tüm verileriniz kalıcı olarak silinecektir.</li>
                                        <li>Bu işlem geri alınamaz.</li>
                                        <li>Hesap silme talebi onaylandıktan sonra 10 gün içerisinde hesabınız silinecektir.</li>
                                        <li>Bu süre içerisinde uygulamaya giriş yaparsanız silme işlemi iptal edilecektir.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="mad-field">
                                <label htmlFor="email">E-Posta Adresi *</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="ornek@email.com"
                                    required
                                    maxLength={100}
                                />
                                <p className="mad-hint">
                                    Mobil uygulama hesabınıza kayıtlı e-posta adresinizi giriniz.
                                </p>
                            </div>

                            <button
                                type="submit"
                                className="mad-btn mad-btn-primary"
                                disabled={loading}
                            >
                                {loading ? 'Gönderiliyor...' : 'Doğrulama Kodu Gönder'}
                            </button>
                        </form>
                    </div>
                )}

                {step === 2 && (
                    <div className="mad-step mad-step-2">
                        <form className="mad-form" onSubmit={handleCodeSubmit}>
                            <div className="mad-info mad-info-success">
                                <div className="mad-info-icon">✉️</div>
                                <div className="mad-info-content">
                                    <h3>E-Posta Gönderildi</h3>
                                    <p>
                                        <strong>{email}</strong> adresine doğrulama kodu gönderildi.
                                        Lütfen e-postanızı kontrol ediniz ve aşağıdaki alana kodu giriniz.
                                    </p>
                                </div>
                            </div>

                            <div className="mad-field">
                                <label htmlFor="verificationCode">Doğrulama Kodu *</label>
                                <input
                                    id="verificationCode"
                                    name="verificationCode"
                                    type="text"
                                    value={verificationCode}
                                    onChange={(e) => setVerificationCode(e.target.value)}
                                    placeholder="6 haneli kod"
                                    required
                                    maxLength={6}
                                    autoComplete="off"
                                />
                                <p className="mad-hint">
                                    E-postanıza gönderilen 6 haneli doğrulama kodunu giriniz.
                                </p>
                            </div>

                            <div className="mad-button-group">
                                <button
                                    type="button"
                                    className="mad-btn mad-btn-secondary"
                                    onClick={handleResetForm}
                                    disabled={loading}
                                >
                                    Geri Dön
                                </button>
                                <button
                                    type="submit"
                                    className="mad-btn mad-btn-danger"
                                    disabled={loading}
                                >
                                    {loading ? 'Onaylanıyor...' : 'Hesap Silme Talebini Onayla'}
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                {step === 3 && (
                    <div className="mad-step mad-step-3">
                        <div className="mad-success">
                            <div className="mad-success-icon">✓</div>
                            <h2>Hesap Silme Talebi Onaylandı</h2>
                            <div className="mad-success-content">
                                <p>
                                    Hesabınız <strong>10 gün içerisinde</strong> kalıcı olarak silinecektir.
                                </p>
                                {deletionInfo?.scheduledDeletionDate && (
                                    <div className="mad-deletion-date">
                                        <strong>Tahmini Silme Tarihi:</strong>
                                        <span>{new Date(deletionInfo.scheduledDeletionDate).toLocaleDateString('tr-TR', {
                                            day: 'numeric',
                                            month: 'long',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}</span>
                                    </div>
                                )}
                                <div className="mad-info mad-info-warning">
                                    <div className="mad-info-icon">ℹ️</div>
                                    <div className="mad-info-content">
                                        <h4>Dikkat!</h4>
                                        <p>
                                            Bu süre içerisinde mobil uygulamaya giriş yaparsanız
                                            hesap silme işlemi otomatik olarak iptal edilecektir.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="mad-btn mad-btn-primary"
                                onClick={() => (window.location.href = '/')}
                            >
                                Ana Sayfaya Dön
                            </button>
                        </div>
                    </div>
                )}

                <div className="mad-help">
                    <h3>Yardıma mı ihtiyacınız var?</h3>
                    <p>
                        Hesap silme işlemi hakkında sorularınız için{' '}
                        <a href="/iletisim">iletişim</a> sayfamızdan bize ulaşabilirsiniz.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MobileAccountDeletion;
